import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class StretchLineWall {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot: marietta.core.Point) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot: marietta.core.Point) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    lineObj: SVGElement;

    dotObj: SVGElement;

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite, id: number) {
      // ラインの作成
      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      (<SVGElement>viewObj).setAttribute('id', `line_${id}`);
      this.lineObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      (this.lineObj).setAttribute('stroke', '#b0b0b0');
      (this.lineObj).setAttribute('stroke-width', '10');
      (this.lineObj).setAttribute('opacity', '.75');
      (this.lineObj).setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
      (<SVGElement>viewObj).appendChild(this.lineObj);

      this.dotObj = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      (this.dotObj).setAttribute('r', '5');
      (this.dotObj).setAttribute('fill', '#8a8a8a');
      (<SVGElement>viewObj).appendChild(this.dotObj);

      this.spt = new SVGSprite(viewObj);

      targetSprite.addChild(this.spt);
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (this.firstDot === undefined || this.secondDot === undefined) return;
      const data: string = marietta.webcad.util.SVGUtil.getPathLineString(this.firstDot, this.secondDot);
      this.lineObj.setAttribute('d', data);
      (this.dotObj).setAttribute('cx', this.secondDot.x.toString());
      (this.dotObj).setAttribute('cy', this.secondDot.y.toString());
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * 線の色の変更
     * @param color
     */
    public set lineColor(color: string) {
      this.spt.element.style.stroke = color;
    }
}
